<script setup>
import ArgonSelect from "@/components/ArgonSelect.vue";

defineProps({
  modelValue: {
    type: String,
    default: "this_month",
  },
});

const emit = defineEmits(["update:modelValue"]);

const options = [
  // { label: "Hoy", value: "today" },
  { label: "Este mes", value: "this_month" },
  { label: "Este trimestre", value: "this_quarter" },
  { label: "Este año", value: "this_year" },
];
</script>

<template>
  <argon-select
    id="analytics-interval-selector"
    :model-value="modelValue"
    name="analytics-interval"
    name-label="label"
    name-value="value"
    :options="options"
    size="sm"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
